import { IconTypesProps } from '@/ui/components/svg/iconTypes'
import { Circle, Path, Svg, G, ClipPath, Rect, Defs } from '@react-pdf/renderer'

const SvgStatusInReview = ({ primaryColor = '#FFFFFF' }: IconTypesProps) => (
    <Svg width="20" height="20" viewBox="0 0 24 24">
        <Circle cx="12" cy="12" r="12" fill="#CCCCCC" />
        <G clip-path="url(#clip0_1016_3070)">
            <Path
                d="M18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 10.4087 6.63214 8.88258 7.75736 7.75736C8.88258 6.63214 10.4087 6 12 6C13.5913 6 15.1174 6.63214 16.2426 7.75736C17.3679 8.88258 18 10.4087 18 12Z"
                stroke="white"
                stroke-width="0.8"
                stroke-linecap="round"
                stroke-linejoin="round"
            />
            <Path
                d="M12.3159 8.52631H11.6843V12.3158L14.9685 14.2105L15.2843 13.661L12.3159 11.9495V8.52631Z"
                fill={primaryColor}
            />
        </G>
        <Defs>
            <ClipPath id="clip0_1016_3070">
                <Rect
                    width="14"
                    height="14"
                    fill={primaryColor}
                    transform="translate(5 5)"
                />
            </ClipPath>
        </Defs>
    </Svg>
)

export default SvgStatusInReview
